import { BookOpen, Building2, GraduationCap } from 'lucide-react';

import { AudienceCard } from '../components/AudienceCard';
import { SectionWrapper } from '../components/SectionWrapper';
import { MARKETING_APP_ENTRY_HREF } from '../marketingContent';

import styles from './AudienceTriageSection.module.css';

export function AudienceTriageSection() {
  return (
    <SectionWrapper background="soft" data-testid="marketing-section-audience-triage">
      <div className={styles.section}>
        <div className={styles.intro}>
          <h2 className={styles.title}>What brings you to Kudu?</h2>
          <p className={styles.subhead}>
            Different paths for different roles. Pick yours to see what&apos;s
            most relevant.
          </p>
        </div>

        <div className={styles.grid}>
          <AudienceCard
            body="Start a free course in 2 minutes with pre-built content, or build a custom course from your own materials. Kudu handles the heavy lifting. You keep the copyright."
            cta="Explore for faculty"
            ctaHref="/faculty"
            emphasis="primary"
            icon={BookOpen}
            title="I teach a course."
          />
          <AudienceCard
            body="Replace your courseware stack with one partner. Protect faculty IP. Make inclusive-access economics actually work. See how campuses are using Kudu."
            cta="Explore for institutions"
            ctaHref="/institutions"
            emphasis="primary"
            icon={Building2}
            title="I lead an institution."
          />
          <AudienceCard
            body="Access your course materials, homework, and AI tutor in one place."
            cta="Go to the app"
            ctaHref={MARKETING_APP_ENTRY_HREF}
            emphasis="muted"
            icon={GraduationCap}
            title="I&apos;m a student."
          />
        </div>
      </div>
    </SectionWrapper>
  );
}
